import { type GoalListResponse, GoalStatus } from '@lmc/ts-common'
import { useMemo } from 'react'
import type { GoalsListItem } from '../GoalsList/GoalsList'
import useGoals from './useGoals'

const useFilteredGoals = (residentID: string | undefined) => {
  const { goals, isLoading } = useGoals(residentID)

  const filteredGoals = useMemo(() => getFilteredGoals(goals), [goals])

  return {
    ...filteredGoals,
    isLoading
  }
}

export const convertGoalListResponseToGoalsListItem = (
  goal: GoalListResponse
): GoalsListItem => ({
  ...goal,
  key: goal.id,
  level: goal.importance,
  titleContent: goal.title,
  iconContent: '',
  status: goal.status as GoalStatus
})

export const getFilteredGoals = (
  goals: GoalListResponse[] | undefined
): FilteredGoals => {
  const doneGoals: GoalsListItem[] = []
  const archivedGoals: GoalsListItem[] = []
  const restGoals: GoalsListItem[] = []

  goals?.forEach((goal) => {
    const convertedGoal = convertGoalListResponseToGoalsListItem(goal)

    if (goal.status === GoalStatus.done) {
      doneGoals.push(convertedGoal)
    } else if (goal.status === GoalStatus.archive) {
      archivedGoals.push(convertedGoal)
    } else {
      restGoals.push(convertedGoal)
    }
  })

  return {
    goals: restGoals,
    doneGoals,
    archivedGoals
  }
}

export type FilteredGoals = {
  goals: GoalsListItem[]
  doneGoals: GoalsListItem[]
  archivedGoals: GoalsListItem[]
}

export type GetListQueryResponse = {
  result?: GoalListResponse[]
}

export default useFilteredGoals
